import { getDefaultMainMenus } from '../models/route-model'
export const state = {
  clipped: false,
  appDrawer: true,
  fixed: true,
  mainNavActive: true,
  showCloseIcon: true,
  mainMenuList: getDefaultMainMenus(),
  activeRouteItem: {
    title: '',
    route: '',
    img: '',
    children: []
  },
  activeSubRouteItem: {
    title: '',
    route: '',
    img: '',
  },
  isResetPassword: null,
  has_credit_note: false,
  is_loaded_home_page_data: false,
  is_loaded_channel_data: true,
  is_loaded_royalty_page_data: false,
  chartReport: {},
  royaltyChartReport: {

  },
  appNavItems: [
    {
      title: 'detailsb2b_royalties',
      route: 'royalties',
      img: 'static/icons/b2b/accounting-active.svg',
      hasPermission: true,
      expandable: true,
      children: []
    },

    {
      title: 'Labels',
      route: 'labels',
      img: 'static/icons/b2b/label-inactive.svg',
      hasPermission: false,
      expandable: false,

      children: [
        { icon: 'Boxer Recordings', title: 'Boxer Recordings', route: 'boxer_recordings', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },
        { icon: 'Boxer Digital', title: 'Boxer Digital', route: 'boxer_digital', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },
        { icon: 'Kick Boxer', title: 'Kick Boxer', route: 'kick_koxer', img: 'static/icons/b2b/label-inactive.svg', parent: 'Labels' },]
    },
    {
      title: 'Releases',
      route: 'releases',
      img: 'static/icons/b2b/booking-grey.svg',
      hasPermission: false,
      expandable: false,
      children: [
        { icon: 'Total 2020', title: 'Total 2020', route: 'total_2020', img: 'static/icons/b2b/booking-grey.svg', parent: 'Releases' },
      ]

    },
    {
      title: 'User Profile',
      route: 'user_profile',
      img: 'static/icons/b2b/user_color.svg',
      hasPermission: false,
      hasParam: false,
      children: []
    },
    {
      title: 'Log Out',
      route: 'b2bLogin',
      img: 'static/icons/b2b/logout_color.svg',
      hasPermission: false,
      hasParam: false,
      children: []
    },


  ],

  royalties: [

  ],
  languages: [],

  selectedRoyaltyItem: {},
  royalty_period_id: '',

  loginUser: {
    email: '',
    password: ''
  },
  resetPassword: {
    username: '',
  },
  user: { given_name: '' },
  is_Logged_In: false,
  is_Loaded_Data: false,
  loading_Text: 'No Data Available',
  loginRedirectRoute: {
    name: 'b2b',
    params: {},
    query: {}
  },
  redirectRoute: '/b2b/home',
  userDetails: {

  },

  userInfo: {

  }
}
